import { observable } from "mobx";
import { api_adm } from "../../api";
import { toast } from "react-toastify";

export class _AgendamentosAdminStore {

  obs = observable({
    resumo_agendamentos: [] as any[],
    loading_resumo_agendamentos: false as boolean
  });

  async handleGetResumoAgendamentos(tipoIntegracao: string) {

    this.obs.loading_resumo_agendamentos = true;

    try {

      let params = {
        tipo_integracao: tipoIntegracao
      }

      let resp = await api_adm.get( "/api/admin/agendamentos/resumo", {params});

      const itens = Array.isArray(resp.data) ? resp.data : resp.data?.itens || [];

      this.obs.resumo_agendamentos = itens.map((item: any) => ({
        periodo: item.periodo,
        dia: String(item.dia || ""),
        empresas: Number(item.empresas) || 0
      }));

    } catch (ex: any) {

      this.obs.resumo_agendamentos = [];

      const mensagem = ex?.response?.data?.erro || "Erro ao carregar o resumo dos agendamentos!";

      toast.error(mensagem);

    } finally {

      this.obs.loading_resumo_agendamentos = false;

    }
  };

  getDadosMensais() {

    return this.obs.resumo_agendamentos
      .filter(item => item.periodo === "mensal")
      .slice()
      .sort((a, b) => Number(a.dia) - Number(b.dia));
  }

  getDadosQuinzenais() {

    return this.obs.resumo_agendamentos
      .filter(item => item.periodo === "quinzenal")
      .slice()
      .sort((a, b) => Number(a.dia) - Number(b.dia));
  }

  getDadosSemanais() {

    return this.obs.resumo_agendamentos
      .filter(item => item.periodo === "semanal")
      .slice()
      .sort((a, b) => {

        const diaA = Number.parseInt(a.dia, 10);
        const diaB = Number.parseInt(b.dia, 10);

        return diaA - diaB;

      });
  }

  handleLimparResumoAgendamentos = (): void => {

    this.obs.resumo_agendamentos = [];
    this.obs.loading_resumo_agendamentos = false;

  };
}

export const AgendamentosAdminStore = new _AgendamentosAdminStore();